export default __webpack_public_path__ + "static/media/fd-logo.96f4dde7.png";